import { render, staticRenderFns } from "./PopupSortPlan.vue?vue&type=template&id=ae15d4b4&"
import script from "./PopupSortPlan.vue?vue&type=script&lang=ts&"
export * from "./PopupSortPlan.vue?vue&type=script&lang=ts&"
import style0 from "./PopupSortPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports